import SEND_EMAIL_LOGIN_WITH_LINK from './sendEmailLoginWithLink.gql';

export {
  SEND_EMAIL_LOGIN_WITH_LINK,
};
